import FormItem from 'antd/es/form/FormItem';
import styled from 'styled-components';
import { media } from '../../../theme/mixins/responsive';
export const StyledFormItem = styled(FormItem) `
  margin-bottom: 0;
  ${({ $hideContent }) => $hideContent
    ? `
      &.ant-form-item:not(.ant-form-item-horizontal){
        .ant-form-item-label{
          padding:0;
          }
          .ant-form-item-control  {
            display:none;
            }
            }
`
    : undefined}
  &.ant-form-item-horizontal {
    display: flex;
    width: 100%;
    .ant-form-item-row {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: ${({ theme }) => theme.spacing.md}px;
      overflow: hidden;
      flex-wrap: nowrap;
      .ant-form-item-label,
      .ant-form-item-control {
        flex: none;

        flex-grow: 0;
        flex-shrink: 0;
      }
      .ant-form-item-label {
        flex-basis: calc(65% - ${({ theme }) => theme.spacing.md / 2}px);
        text-align: left;
        & > label {
          height: auto;
        }
      }
      .ant-form-item-control {
        flex-basis: calc(35% - ${({ theme }) => theme.spacing.md / 2}px);
        justify-content: center;
        display: flex;
      }

      ${media.tablet `
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        gap: ${({ theme }) => theme.spacing.sm}px;

      .ant-form-item-label {
        flex-basis: 100%;
  
      }
      .ant-form-item-control {
        flex-basis: 100%;
      }
      `}
    }
  }
  &.ant-form-item:not(.ant-form-item-horizontal) .ant-form-item-label {
    padding: 0;
  }
  .ant-form-item-label {
    label {
      width: 100%;
      &:after {
        display: none;
      }
    }
  }
  .ant-form-item-required {
    &:after,
    &:before {
      display: none !important;
    }
    .hd-form-label {
      &:after {
        display: inline-block;
        margin-inline-start: 4px;
        color: #ff4d4f;
        font-size: 16px;
        font-family: SimSun, sans-serif;
        line-height: 1;
        content: '*';
      }
    }
  }
`;
